import router from './index'
import { getLocal } from '@/utils/auth'

// 白名单页面直接进入
const whiteList = ['/login']
// console.log(whiteList)

router.beforeEach((to, from, next) => {
  const token = getLocal('token')
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  //   NProgress.done()
})
